<!-- <div class="main-content">
  <div class="container-fluid">
    <div *ngIf="!loading" class="alert alert-info">
      Estado: Datos cargados
      <br />
      Número de registros: {{ data?.length || 0 }}
    </div>

    <div class="row">
      <div class="col-8">
        <h3 class="d-inline-block">Surcharges</h3>
      </div>
      <div class="col-4 text-right">
        <button class="btn btn-success" (click)="addNew()">
          <i class="material-icons">add</i>
          <span>AGREGAR</span>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div *ngIf="loading" class="text-center p-3">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
            </div>

            <div
              class="table-responsive"
              *ngIf="!loading && data && data.length > 0"
            >
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Items</th>
                    <th>Surcharge</th>
                    <th>Apply</th>
                    <th>Category</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let item of data; let i = index"
                    [ngClass]="{
                      'table-success': i % 8 === 0,
                      'table-warning': i % 8 === 2,
                      'table-info': i % 8 === 4,
                      'table-danger': i % 8 === 6
                    }"
                  >
                    <td>{{ item.name }}</td>
                    <td>{{ item.items?.length || 0 }}</td>
                    <td>${{ item.surcharge }}</td>
                    <td>{{ item.apply }}</td>
                    <td>{{ item.category || "N/A" }}</td>
                    <td>
                      <button
                        class="btn btn-danger btn-link btn-sm"
                        (click)="deleteData(item._id)"
                      >
                        <i class="material-icons">delete</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              *ngIf="!loading && (!data || data.length === 0)"
              class="alert alert-warning"
            >
              No hay datos disponibles
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
 -->

<div class="container-fluid py-4">
  <!-- <h4 class="h4">(Courier Charges)</h4> -->
  <div class="row justify-content-center mb-0">
    <div class="col column" *ngFor="let card of resumenCardsTwo; let i = index">
      <div
        class="card card-stats__two"
        [ngClass]="{ 'card-stats__two--selected': i === 2 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 4 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 4, 'text-white': i !== 4 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 4 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row justify-content-center">
      <div
        class="col-2"
        *ngFor="let card of resumenCards.slice(0, 2); index as i"
      >
        <div
          class="card card-stats"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4 class="card-title mb-0 text-white">{{ card.value }}</h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small class="desc">{{ card.desc }}</small>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  <!-- <div class="row justify-content-center">
      <div
        class="col-2"
        *ngFor="let card of resumenCards.slice(2); index as i"
      >
        <div
          class="card card-stats mt-0"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4 class="card-title mb-0 text-white">{{ card.value }}</h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small class="desc">{{ card.desc }}</small>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  <!-- Campo de búsqueda mejorado con autocompletado -->
  <!-- <br /><br /><br /> -->
  <div class="row mb-3 mt-1">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterCourier()"
          list="suggestionsCourier"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestionsCourier">
          <option
            *ngFor="let suggestion of searchSuggestions"
            [value]="suggestion"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <div class="card-tools">
    <!-- Título centrado -->
    <!-- <div class="row mb-3">
      <div class="col-12 text-center">
        <h3 class="fw-bold">Customer Charges</h3>
      </div>
    </div> -->

    <div class="row">
      <div class="col-12">
        <!-- <a
          class="btn btn-dark btn-sm btn-fees-selected"
          [routerLink]="['/logistics/fees/surcharges']"
          [ngClass]="{ 'btn-fees-selected': step === 0 }"
        >
          Customer Charges
        </a> -->
        <a
          class="btn btn-dark btn-sm btn-fees"
          [ngClass]="{ 'btn-fees-selected': step === 0 }"
          (click)="getData()"
        >
          General
        </a>
        <a
          class="btn btn-dark btn-sm btn-fees"
          [ngClass]="{ 'btn-fees-selected': step === 1 }"
          (click)="onHotelsClick()"
        >
          Hoteles
        </a>
        <a
          [routerLink]="['/logistics/fees/surcharges/create']"
          class="btn btn-dark btn-sm btn-new"
        >
          Add item
        </a>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Name</th>
              <th>Items</th>
              <th>Surcharge</th>
              <th>Apply</th>
              <th>Status</th>
              <!-- <th class="th__status">Status</th> -->
              <th class="th__status">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td>
                <a
                  [routerLink]="['/logistics/fees/surcharges/edit', item._id]"
                  class="text-dark"
                >
                  {{ item.name }}
                </a>
              </td>
              <td>{{ item.items?.length || 0 }}</td>
              <td>${{ item.surcharge }}</td>
              <td>{{ item.apply }}</td>
              <td>
                <span
                  class="badge span__badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </span>
              </td>
              <td>
                <a
                  class="btn btn-link text-dark btn-sm btn-del"
                  routerLink="/fees/surcharges/edit/{{ item._id }}"
                  ><i class="fas fa-pen"></i
                ></a>
                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
